import { DomainException } from './domain-exception';

export class StorageException extends DomainException {
  constructor(message = 'No se pudo acceder al almacenamiento local') {
    super(message);
  }
}
